import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter, HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Subscription} from 'rxjs';
import {MatAutocomplete} from '@angular/material/autocomplete';
import { ColorScheme } from '@lib/models/color-scheme/color-scheme';
import { LayoutService } from '@utils/services/layout/layout.service';

@Component({
  selector: 'lib-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
})
export class InputComponent implements OnInit, OnDestroy {

  @Input() public inputControl = new FormControl('');
  @Input() public showClearButton = false;
  @Input() public focusOnInit = false;
  @Input() public placeholder = '';
  @Input() public type = 'text';
  @Input() public autocomplete: MatAutocomplete;
  @Input() public colorScheme: ColorScheme;
  @HostBinding('class.invalid') @Input() public invalid = false;
  @HostBinding('class.focused') @Input() public focused = false;
  @HostBinding('class.disabled') @Input() public disabled = false;
  @Output() public valueChange = new EventEmitter<string>();
  private valueChange$: Subscription;
  @ViewChild('inputRef', { read: ElementRef }) public set inputRef (ref: ElementRef) {
    const input = ref?.nativeElement;
    if (input && this.focusOnInit) {
      input.focus()
    }
  }
  @HostBinding('className') private className: string;

  constructor() {}

  public ngOnInit() {
    if (LayoutService.colorScheme === ColorScheme.Dark && !this.colorScheme) {
      this.colorScheme = ColorScheme.Dark;
    }
    if (this.colorScheme) {
      this.className = this.colorScheme.main;
    }
    this.valueChange$ = this.inputControl.valueChanges.subscribe((input: string) => {
      this.valueChange.emit(input);
    });
  }

  public ngOnDestroy(): void {
    this.valueChange$?.unsubscribe();
  }

  public onFocus(focused: boolean): void {
    this.focused = focused;
    if (focused) {
      this.invalid = false;
      return;
    }
    if (this.inputControl.dirty) {
      if (this.type === 'email') {
        this.inputControl.setValue(this.inputControl.value.trim());
      }
      this.invalid = !this.inputControl.valid;
    }
  }

  public get value(): string {
    return this.inputControl?.value;
  }

  public resetValue(): void {
    this.inputControl.setValue('');
  }

}
